'use client'

import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import type clsx from 'clsx'
import type { ReactNode } from 'react'

import { useTopNav } from '@src/components/TopNavV4/TopNavContext'
import { TopNavMobileCloseHeader } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileCloseHeader'
import { TopNavMobileMenu } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileMenu'
import { TopNavMobileSubMenu } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileSubMenu'
import { useBreakpoints } from '@src/utils/breakpoints.util'
import { cn } from '@src/utils/tailwind'

const asideClassNames =
  'size-full bg-bodi-black-text bg-linear-to-t from-white/10 to-white/0 text-white z-max duration-200 transition-all transition ease-out flex flex-col'

const Panel = ({
  open,
  onClose,
  className,
  content,
}: {
  open: boolean
  onClose: () => void
  className?: clsx.ClassValue
  content: ReactNode
}) => {
  return (
    <Dialog
      transition
      className="relative z-max transition duration-200 ease-out"
      onClose={onClose}
      open={open}
      static
    >
      <Transition show={open} as="div" className="fixed inset-0">
        <TransitionChild>
          <DialogPanel className={cn(asideClassNames, className)}>
            <TopNavMobileCloseHeader onClick={onClose} />
            <div className="flex-1 overflow-y-auto">{content}</div>
          </DialogPanel>
        </TransitionChild>
      </Transition>
    </Dialog>
  )
}

export const TopNavMobileSlidingPanel = () => {
  const { isExpanded, isMobileSubExpanded, setExpanded, setMobileSubExpanded } = useTopNav()
  const { isDesktop } = useBreakpoints()

  return (
    <>
      <Panel
        open={isExpanded && !isMobileSubExpanded && !isDesktop}
        onClose={() => setExpanded(false)}
        content={<TopNavMobileMenu />}
        className="data-closed:-translate-x-full"
      />

      <Panel
        open={isMobileSubExpanded && !isDesktop}
        onClose={() => {
          setExpanded(false)
          setMobileSubExpanded(false)
        }}
        content={<TopNavMobileSubMenu />}
        className={{
          'data-closed:translate-x-full': isExpanded,
          'data-closed:-translate-x-full': !isExpanded,
        }}
      />
    </>
  )
}
